import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { of } from 'rxjs';
import { TempStorageService } from './temp-storage.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EntityPickingService extends TempStorageService {
  /**
   * Creates an instance of pick service.
   * @param apiService: ApiService
   */
  constructor(public apiService: ApiService) {
    super();
  }
  /**
   * Gets all
   * @returns Observable<any>
   */
  getAll() {
    const entityPickingStorage = this.getStorage(environment.entityPicking);
    return entityPickingStorage
      ? of(entityPickingStorage)
      : this.apiService
        .get(`${this.apiService.businessEntity}/entities/picking`)
        .pipe(tap(res => this.setStorage(environment.entityPicking, res)));
  }
  /**
   * Gets setting storage
   * @returns any
   */
  getSettingStorage() {
    return this.getStorage(environment.entityPicking);
  }

  setSettingStorage(item:any) {
    return this.setStorage(environment.entityPicking, item);
  }
}
